module.exports = __webpack_public_path__ + "static/media/log-out-icon.9202e360.svg";